import React, { useEffect } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import ROUTES from '../constants';
import Tiah from '../../../pages/Tiah';
import TiahMobile from '../../../pages/Tiah/TiahMobile';
import TiahDealerMap from '../../../pages/Tiah/TiahDealerMap';
import UnauthenticatedRoute from '../../../pages/UnauthenticatedRoute';
import TiahVerification from '../../../pages/Tiah/TiahVerification';

function RoutesTiah() {
  const history = useHistory();

  // Add facebook tracking pixels for Marketing analytics
  // script and noscript tag for fallback
  useEffect(() => {
    if (process.env.REACT_APP_CUSTOM_NODE_ENV !== 'prod') {
      return;
    }

    let script = document.getElementById('fb_script');
    let noScript = document.getElementById('fb_no_script');

    if (script || noScript) {
      return;
    }

    script = document.createElement('script');
    script.id = 'fb_script';
    script.async = true;
    script.text = `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '4949902111704427');
      fbq('track', 'PageView');`;
    document.head.appendChild(script);

    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style = 'display:none';
    img.src =
      'https://www.facebook.com/tr?id=4949902111704427&ev=PageView&noscript=1';

    noScript = document.createElement('noscript');
    noScript.id = 'fb_no_script';
    noScript.appendChild(img);
    document.head.appendChild(noScript);
  }, []);

  // Remove facebook tracking pixel if not on TIAH route
  useEffect(() => {
    if (process.env.REACT_APP_CUSTOM_NODE_ENV !== 'prod') {
      return undefined;
    }

    return history.listen(location => {
      const pathName = location.pathname;

      if (!pathName.includes('tiah')) {
        const script = document.getElementById('fb_script');
        const noScript = document.getElementById('fb_no_script');

        if (script && noScript) {
          script.remove();
          noScript.remove();
        }
      }
    });
  }, [history]);

  return (
    <Switch>
      <Route exact path={ROUTES.TIAH}>
        <UnauthenticatedRoute component={Tiah} />
      </Route>
      <Route exact path={ROUTES.TIAH_DEALER_MAP}>
        <UnauthenticatedRoute component={TiahDealerMap} />
      </Route>
      <Route exact path={ROUTES.TIAH_MOBILE_NUMBER}>
        <UnauthenticatedRoute component={TiahMobile} />
      </Route>
      <Route exact path={ROUTES.TIAH_MOBILE_VERIFICATION}>
        <UnauthenticatedRoute component={TiahVerification} />
      </Route>
    </Switch>
  );
}

export default RoutesTiah;
